/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicinePatientAliases {
  ACTION_MEDICINE_DELETE = 'action-medicine-delete',
  ACTION_MEDICINE_EDIT = 'action-medicine-edit',
  ACTION_MEDICINE_INACTIVATE = 'action-medicine-inactivate',
  ACTION_MEDICINE_RELEASE = 'action-medicine-release',
  AUTOCOMPLETE_MATERIAL = 'autocomplete-material',
  AUTOCOMPLETE_UNIT_MEASUREMENT = 'autocomplete-unit-measurement',
  BREADCRUMB_MEDICINE = 'breadcrumb-medicine',
  BTN_SEND_DOCUMENT = 'btn-send-document',
  CHECKBOX_DONT_KNOW_DOSE = 'checkbox-dont-know-dose',
  CONTEXTUAL_BAR_MEDICINE_PATIENT = 'contextual-bar-medicine-patient',
  DATE_FIELD_END_DATE = 'date-field-end-date',
  DATE_FIELD_START_DATE = 'date-field-start-date',
  FETCH_MATERIAL = 'fetch-material',
  FETCH_UNIT_MEASUREMENT = 'fetch-unit-measurement',
  FIELD_CONTINUOUS_MEDICATION = 'field-continuous-medication',
  FIELD_CONTINUOUS_MEDICATION_DETAIL = 'field-continuous-medication-detail',
  FIELD_DONT_KNOW_DOSE = 'field-dont-know-dose',
  FIELD_DONT_KNOW_DOSE_DETAIL = 'field-dont-know-dose-detail',
  FIELD_DOSE = 'field-dose',
  FIELD_DOSE_DETAIL = 'field-dose-detail',
  FIELD_END_DATE = 'field-end-date',
  FIELD_END_DATE_DETAIL = 'field-end-date-detail',
  FIELD_INACTIVATE_DATE = 'field-inactivate-date',
  FIELD_INTERVAL = 'field-interval',
  FIELD_INTERVAL_DETAIL = 'field-interval-detail',
  FIELD_MEDICINE = 'field-medicine',
  FIELD_MEDICINE_DETAIL = 'field-medicine-detail',
  FIELD_NOTES = 'field-notes',
  FIELD_RELEASE_DATE = 'field-release-date',
  FIELD_START_DATE = 'field-start-date',
  FIELD_START_DATE_DETAIL = 'field-start-date-detail',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FIELD_UNIT_MEASUREMENT_DETAIL = 'field-unit-measurement-detail',
  FIELD_UNREGISTERED_MEDICINE = 'field-unregistered-medicine',
  FIELD_UNREGISTERED_MEDICINE_DETAIL = 'field-unregistered-medicine-detail',
  FORM_MEDICINE_PATIENT = 'form-medicine-patient',
  INPUT_CONTINUOUS_MEDICATION_DETAIL = 'input-continuous-medication-detail',
  INPUT_DONT_KNOW_DOSE_DETAIL = 'input-dont-know-dose-detail',
  INPUT_DOSE = 'input-dose',
  INPUT_DOSE_DETAIL = 'input-dose-detail',
  INPUT_END_DATE_DETAIL = 'input-end-date-detail',
  INPUT_INACTIVATE_DATE = 'input-inactivate-date',
  INPUT_INTERVAL = 'input-interval',
  INPUT_INTERVAL_DETAIL = 'input-interval-detail',
  INPUT_MEDICINE_DETAIL = 'input-medicine-detail',
  INPUT_NOTES = 'input-notes',
  INPUT_RELEASE_DATE = 'input-release-date',
  INPUT_START_DATE_DETAIL = 'input-start-date-detail',
  INPUT_UNIT_MEASUREMENT_DETAIL = 'input-unit-measurement-detail',
  INPUT_UNREGISTERED_MEDICINE = 'input-unregistered-medicine',
  INPUT_UNREGISTERED_MEDICINE_DETAIL = 'input-unregistered-medicine-detail',
  LAYOUT_MEDICINE_PATIENT = 'layout-medicine-patient',
  MAPPER_MATERIAL = 'mapper-material',
  MAPPER_UNIT_MEASUREMENT = 'mapper-unit-measurement',
  PANEL_MEDICINE_PATIENT = 'panel-medicine-patient',
  RADIO_CONTINUOUS_MEDICATION = 'radio-continuous-medication',
  TEXT_MATERIAL = 'text-material',
  TEXT_UNIT_MEASUREMENT = 'text-unit-measurement',
}
export { MyChartMedicinePatientAliases };
